import { combineReducers, configureStore } from '@reduxjs/toolkit';
import logger from 'redux-logger';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { createStateSyncMiddleware, initMessageListener } from 'redux-state-sync';
import thunk from 'redux-thunk';

import accountsSetupReducer from './slices/accountsSetupSlice';
import addEditClassModalReducer from './slices/addEditClassModalSlice';
import addEditEmployeeModalReducer from './slices/addEditEmployeeModalSlice';
import addEditExOpInvoiceReducer from './slices/addEditExOpInvoiceSlice';
import addEditExOpReceiptModalReducer from './slices/addEditExOpReceiptModalSlice';
import addEditInvoiceReducer from './slices/addEditInvoiceSlice';
import addEditMultiExpensesModalReducer from "./slices/addEditMultiExpensesModalSlice";
import addEditMultiPaymentsModalReducer from "./slices/addEditMultiPaymentsModalSlice";
import addEditParentModalReducer from './slices/addEditParentModalSlice';
import addEditPaymentVoucherModalReducer from "./slices/addEditPaymentVoucherModalSlice";
import addEditPurchasesModalReducer from "./slices/addEditPurchasesModalSlice";
import addEditReceiptModalReducer from './slices/addEditReceiptModalSlice';
import addEditRegistrationAdvanceModalReducer from './slices/addEditRegistrationAdvanceModalSlice';
import addEditRegistrationSimpleModalReducer from './slices/addEditRegistrationSimpleModalSlice';
import addEditStudentModalReducer from './slices/addEditStudentModalSlice';
import AIGenerationModalReducer from './slices/AIGenerationModalSlice';
import loginReducer from './slices/authSlice';
import bannersModalReducer from './slices/bannersModalSlice';
import calendarPreviewModalReducer from './slices/calendarPreviewModalSlice';
import chatsReducer from './slices/chatsSlice';
import childrenReducer from './slices/childrenSlice';
import employeesListReducer from './slices/employeesListSlice';
import evaluationReducer from './slices/evaluationSlice';
import examCopyModalReducer from './slices/examCopyModalSlice';
import examGradesModalReducer from './slices/examGradesModalSlice';
import generalSlice from './slices/generalSlice';
import langReducer from './slices/langSlice';
import lessonPlannerReducer from './slices/lessonPlannerSlice';
import mediaApprovalModalReducer from './slices/mediaApprovalModalSlice';
import navigationReducer from "./slices/navigationSlice";
import parentsListReducer from './slices/parentsListSlice';
import preferencesReducer from './slices/preferencesSlice';
import selectedClassReducer from './slices/selectedClassSlice';
import studentListReducer from './slices/studentListSlice';
import subLessonModalReducer from './slices/subLessonModalSlice';
import themeReducer from './slices/themeSlice';
import updateSchoolModalReducer from './slices/updateSchoolModalSlice';
import updateZatcaModalReducer from './slices/updateZatcaModalSlice';
import userTimelineCommentsModalReducer from './slices/userTimelineCommentsModalSlice';
import userTimelineListModalReducer from './slices/userTimelineListModalSlice';

const rootReducer = combineReducers({
  auth: loginReducer,
  selectedClass: selectedClassReducer,
  language: langReducer,
  children: childrenReducer,
  lessonPlanner: lessonPlannerReducer,
  theme: themeReducer,
  preferences: preferencesReducer,
  chats: chatsReducer,
  updateSchoolModal: updateSchoolModalReducer,
  updateZatcaModal: updateZatcaModalReducer,
  addEditClassModal: addEditClassModalReducer,
  addEditParentModal: addEditParentModalReducer,
  addEditStudentModal: addEditStudentModalReducer,
  addEditEmployeeModal: addEditEmployeeModalReducer,
  addEditRegistrationSimpleModal: addEditRegistrationSimpleModalReducer,
  addEditReceiptModal: addEditReceiptModalReducer,
  addEditExOpReceiptModal: addEditExOpReceiptModalReducer,
  addEditRegistrationAdvanceModal: addEditRegistrationAdvanceModalReducer,
  addEditInvoice: addEditInvoiceReducer,
  addEditExOpInvoice: addEditExOpInvoiceReducer,
  studentList: studentListReducer,
  parentsList: parentsListReducer,
  employeesList: employeesListReducer,
  examGradesModal: examGradesModalReducer,
  examCopyModal: examCopyModalReducer,
  calendarPreviewModal: calendarPreviewModalReducer,
  userTimelineListModal: userTimelineListModalReducer,
  userTimelineCommentsModal: userTimelineCommentsModalReducer,
  bannersModal: bannersModalReducer,
  mediaApprovalModal: mediaApprovalModalReducer,
  evaluation: evaluationReducer,
  addEditPaymentVoucherModal: addEditPaymentVoucherModalReducer,
  addEditMultiPaymentsModal: addEditMultiPaymentsModalReducer,
  addEditMultiExpensesModal: addEditMultiExpensesModalReducer,
  addEditPurchasesModal: addEditPurchasesModalReducer,
  navigation: navigationReducer,
  accountsSetup: accountsSetupReducer,
  generalData: generalSlice,
  subLessonModal: subLessonModalReducer,
  AIGenerationModal: AIGenerationModalReducer,
});

const persistConfig = {
  key: 'academic-ieducore-com',
  storage,
  whitelist: ['auth', 'selectedClass', 'language', 'theme', 'preferences']//put name of reducers you want to put in storage
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

// redux-state-sync for syncing state between tabs
const stateSyncConfig = {
  // The key used to identify the state in localStorage
  channel: 'redux-state-sync-academic-ieducore-com',
  // The storage to use (localStorage or sessionStorage)
  broadcastChannelOption: { type: 'localstorage' },
  // The list of actions to ignore
  // blacklist: ['persist/PERSIST', 'persist/REHYDRATE'],
  whitelist: ['auth/setAuthentication', 'auth/unsetAuthentication'],
  // predicate: action => action.type === 'login/setAuthentication',
};
const stateSyncMiddleware = createStateSyncMiddleware(stateSyncConfig);


/**
 * Store
 */
export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: [thunk, stateSyncMiddleware]//logger
});
export const persistor = persistStore(store)

initMessageListener(store);

